(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["confettiies-instagram"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cf-instagram__carousel').forEach(carousel => {
    const interval = carousel.getAttribute('xo-autoplay');
    const pause = () => carousel.setAttribute('xo-autoplay', '0');
    const resume = () => {
      if (interval && !Array.from(carousel.querySelectorAll('video')).some(video => !video.paused) && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) carousel.setAttribute('xo-autoplay', interval);
    };
    carousel.addEventListener('play', pause, true);
    carousel.addEventListener('pause', resume, true);
    carousel.addEventListener('ended', resume, true);
    carousel.addEventListener('focusin', pause);
    carousel.addEventListener('focusout', event => { if (!carousel.contains(event.relatedTarget)) resume(); });
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) pause();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-v3"]) return;
  try {
    
  (() => {
    const footerMenuGroups = document.querySelectorAll('.footer-v16__menu-group');
    const desktopFooter = window.matchMedia('(min-width: 768px)');

    const syncFooterMenuGroups = (event) => {
      footerMenuGroups.forEach((menuGroup) => {
        menuGroup.open = event.matches;
      });
    };

    syncFooterMenuGroups(desktopFooter);
    desktopFooter.addEventListener('change', syncFooterMenuGroups);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-v2"]) return;
  try {
    
document.querySelectorAll('[data-announcement-carousel]').forEach((carousel) => {
  const track = carousel.querySelector('[data-announcement-track]');
  const slides = Array.from(carousel.querySelectorAll('[data-announcement-slide]'));
  const previous = carousel.querySelector('[data-announcement-prev]');
  const next = carousel.querySelector('[data-announcement-next]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!track || slides.length < 2 || !previous || !next || carousel.dataset.initialized) return;
  carousel.dataset.initialized = 'true';
  const clone = (slide) => {
    const copy = slide.cloneNode(true);
    copy.removeAttribute('data-announcement-slide');
    copy.setAttribute('data-announcement-clone', '');
    copy.setAttribute('aria-hidden', 'true');
    copy.classList.remove('is-active');
    return copy;
  };
  track.prepend(clone(slides[slides.length - 1]));
  track.append(clone(slides[0]));
  const items = Array.from(track.children);
  let position = 1;
  let timer;
  let resetTimer;
  let moving = false;
  const render = (animate = true) => {
    track.style.transition = animate && !reducedMotion.matches ? 'transform .4s ease' : 'none';
    track.style.transform = 'translateX(' + (-position * 100) + '%)';
    items.forEach((slide, index) => {
      slide.classList.toggle('is-active', index === position);
      slide.setAttribute('aria-hidden', String(index !== position || slide.hasAttribute('data-announcement-clone')));
    });
  };
  const finish = () => {
    clearTimeout(resetTimer);
    if (position === 0 || position === items.length - 1) {
      position = position === 0 ? slides.length : 1;
      items.forEach(slide => { slide.style.transition = 'none'; });
      render(false);
      requestAnimationFrame(() => requestAnimationFrame(() => {
        items.forEach(slide => { slide.style.transition = ''; });
      }));
    }
    moving = false;
  };
  const move = (direction) => {
    if (moving) return;
    moving = true;
    position += direction;
    render();
    resetTimer = setTimeout(finish, reducedMotion.matches ? 0 : 420);
  };
  const start = () => {
    clearInterval(timer);
    if (reducedMotion.matches || document.hidden || carousel.contains(document.activeElement) || carousel.matches(':hover')) return;
    timer = setInterval(() => move(1), 5000);
  };
  previous.addEventListener('click', () => { move(-1); start(); });
  next.addEventListener('click', () => { move(1); start(); });
  track.addEventListener('transitionend', event => { if (event.target === track && event.propertyName === 'transform') finish(); });
  let touchX = 0;
  let touchY = 0;
  carousel.addEventListener('touchstart', event => {
    touchX = event.changedTouches[0].clientX;
    touchY = event.changedTouches[0].clientY;
    clearInterval(timer);
  }, { passive: true });
  carousel.addEventListener('touchend', event => {
    const dx = event.changedTouches[0].clientX - touchX;
    const dy = event.changedTouches[0].clientY - touchY;
    if (Math.abs(dx) > 36 && Math.abs(dx) > Math.abs(dy)) move(dx < 0 ? 1 : -1);
    start();
  }, { passive: true });
  carousel.addEventListener('mouseenter', () => clearInterval(timer));
  carousel.addEventListener('mouseleave', start);
  carousel.addEventListener('focusin', () => clearInterval(timer));
  carousel.addEventListener('focusout', event => { if (!carousel.contains(event.relatedTarget)) start(); });
  document.addEventListener('visibilitychange', start);
  reducedMotion.addEventListener('change', start);
  render(false);
  start();
});


  } catch(e) { console.error(e); }
})();
})();
